import React from 'react';
import { IData, IStudioParams } from '@/pages/home/pages/studio/type';
import CommonPageRender from '@home/components/CommonPageRender';
import { PAGE_CONFIG_API } from '@home/_config/constant';
import { useParams } from 'react-router-dom';
import { PAGE_CONFIG } from './pageConfig';
import { IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';
import './index.scss';

const CasualOverview = (props: IData) => {
  const { studioInfo  } = props;
  const { studioId } = useParams() as IStudioParams;

  return (
    <div className="dbh-casual-overview">
      <CommonPageRender
        key={studioId}
        reqParams={'/home'}
        frameType="studio"
        pageConfigInit={PAGE_CONFIG as unknown as IPageConfigType}
        api={PAGE_CONFIG_API}
        studioData={studioInfo?.data}
      />
    </div>
  );
};

export default CasualOverview;
